import { SM_CONSTANTS } from './../../../shared/constants/sm-constants';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { CustomConfirmDialogComponent } from 'src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component';

@Component({
  selector: 'sm-purchased-plan-for-renew',
  templateUrl: './purchased-plan-for-renew.component.html',
  styleUrls: ['./purchased-plan-for-renew.component.scss']
})
export class PurchasedPlanForRenewComponent implements OnInit, OnDestroy {
  loader:boolean = false
  _apiSubscription: Subscription
  entitySubscriptionHistoryData: any = []
  constructor(private route: ActivatedRoute,private _navService: NavigationService, private _apiService: ApiService, private loaderService: LoaderServiceService, private _router: Router, private dialog:MatDialog) {
    this._navService.hideSidebarAndNav = false;


    this._apiSubscription =  this._apiService.apiResult.subscribe((resData) => {

      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_SUBSCRIPTION_HISTORY_BY_ID){ 
        this.entitySubscriptionHistoryData = []

          if(resData.result){
            this.entitySubscriptionHistoryData = resData.result 
             
            this.loaderService.showLoader = false
            this.loader = false
            
          }else{
            this.loaderService.showLoader = false
            this._router.navigate(['../plans-list'], {queryParamsHandling: 'preserve', relativeTo: this.route});
          }
          
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_SUBSCRIPTION_INFO){ 
        if(resData.result){
         this.loaderService.showLoader = false
         sessionStorage.setItem('showToastAfterRechargeBusiness','1')
         this._router.navigate(['/businesses','details','plan-and-renew'], {queryParamsHandling: 'preserve'})
         
        }
       }
   });
  }
  onnewpackadd(){
    this._router.navigate(['../plans-list'],{queryParamsHandling: 'preserve', relativeTo: this.route});
  }
  entityHashId: string = '';
  countryInfo:any = typeof sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT) == 'string' ? JSON.parse(sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT)!) : sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT)
  
  ngOnInit(): void {
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash
      
    })
    this.loader = true
    this.loaderService.showLoader = true
    this._apiService.getSubcriptionHistoryById(localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID), '0',this.countryInfo.countryCode)
  }

  goToCreateBusiness(item:any){
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
      data : {
        title : 'Alert',
        message : 'Are you sure you want to add the business on this subscription?',
        okbtn : 'Confirm',
        cancelbtn : 'Cancel',
        type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
      },
      disableClose : true
    });
    dialogRef.afterClosed().subscribe(result=>{
      console.log(result);
      if(result){ 
      sessionStorage.setItem(SM_CONSTANTS.SELECTED_PURCHASED_PLAN, JSON.stringify(item))
      this._router.navigate(['business-create'])
      }
    })    
  }

  // ------------- RENEW FUNCTIONS ------------------
  selectedPlan: any = []
  createBusinessWithExistingSubs(item:any){
    // if(confirm("Are you sure you want to add the business on this subscription?")){
    //   this.selectedPlan = []
    //   this.selectedPlan.push(item)
    //   this.toShowForm = true
    //   this.toShowExistingPlans = false
    // }

    const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
      data : {
        title : 'Alert',
        message : 'Are you sure you want to renew the current business on this subscription?',
        okbtn : 'Confirm',
        cancelbtn : 'Cancel',
        type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
      },
      disableClose : true
    });
    dialogRef.afterClosed().subscribe(result=>{
      console.log(result);
      if(result){ 
        this.loaderService.showLoader = true
        this.selectedPlan = []
      this.selectedPlan.push(item)
      let data = {
        subscriptionInfo : {  
          fromDate: this.formatDateString(new Date()),
          toDate: this.addDaysToDate(new Date(), this.selectedPlan[0].validity),  
          oldEntitySubscriptionActHash: "",
          subscriptionStatus: ""
        }
      }
      // this.loaderService.showLoader = false
      this.loaderService.showLoader = true
      this._apiService.updateEntitySubsciptionInfo(this.entityHashId, this.selectedPlan[0].hash_id,data)
      // this.toShowForm = true
      // this.toShowExistingPlans = false
      }
    })

  


  }

  formatDateString(inputDateString: Date): string {
    const inputDate = new Date(inputDateString);
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
    const day = inputDate.getDate().toString().padStart(2, '0');
    const hours = inputDate.getHours().toString().padStart(2, '0');
    const minutes = inputDate.getMinutes().toString().padStart(2, '0');
    const seconds = inputDate.getSeconds().toString().padStart(2, '0');
  
    return `${year}-${month}-${day}`;
  }

  addDaysToDate(currentDate: Date, daysToAdd: number): string {
    const newDate = new Date(currentDate);
    newDate.setDate(newDate.getDate() + daysToAdd);

    const year = newDate.getFullYear();
    const month = String(newDate.getMonth() + 1).padStart(2, '0');
    const day = String(newDate.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe()
  }
}
